import { List } from 'antd';
import Marquee from "react-fast-marquee";
import Localize from '../../utils/string';


interface Props {
    bannerData?: any
}

const ReleasesHeading = (Props: Props) => {
    return (
        <div className="releases-heading" data-testid="heading">
            <Marquee speed={60} pauseOnHover>
                <List
                    dataSource={Props?.bannerData}
                    renderItem={item => <List.Item>{Props?.bannerData}</List.Item>}
                />
            </Marquee>
        </div>
    )
}

export default ReleasesHeading;